import { Fragment } from 'react';

import { Router, Switch, Route } from "react-router-dom";
import { createBrowserHistory } from "history";
import ReactGA from "react-ga";

import { WonderPush } from 'react-wonderpush';

import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import Chat from "./pages/Chat";
import Login from "./pages/Login";
import Recovery from "./pages/Recovery";
import Register from "./pages/Register";
import AutoLogin from "./pages/AutoLogin";
import Settings from "./pages/Settings";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import PhoneLogin from "./pages/PhoneLogin";


import { hotjar } from 'react-hotjar';
import ReactPixel from 'react-facebook-pixel';






import { setDefaultTranslations, setDefaultLanguage } from 'react-multi-lang';
import { languageService } from './pages/lang/Lang';

import en from './pages/lang/en.json';
import it from './pages/lang/it.json';
import de from './pages/lang/de_new.json';
import ar from './pages/lang/ar.json';
import es from './pages/lang/es.json';
import fr from './pages/lang/fr.json';
import bg from './pages/lang/bg.json';
import sr from './pages/lang/sr.json';



function initializeHotjar() {
  hotjar.initialize(process.env.REACT_APP_HOTJAR_ID || 3402217, process.env.REACT_APP_HOTJAR_VERSION || 6);


}

function initializeFB() {

  const advancedMatching = {}; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
  const options = {
    autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
    debug: false, // enable logs
  };



  ReactPixel.init(process.env.REACT_APP_FB_PIXEL_ID || '1119490712777817', advancedMatching, options);
  ReactPixel.pageView(); // For tracking page view
}



function initializeReactGA() {
  ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID || "UA-195921144-16", {
    gaOptions: {
      cookieDomain: "auto",
    },
  });

  ReactGA.pageview(window.location.pathname + window.location.search);
}

const history = createBrowserHistory();

history.listen((location) => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
});

function App() {

  initializeFB();
  initializeReactGA();
  initializeHotjar();

  setDefaultTranslations({ en, it, de, ar, es, fr, bg, sr })
  setDefaultLanguage('en')

  const searchParams = new URLSearchParams(window.location.search);
  const langParam = searchParams.get("lang");
  if (langParam) {
    languageService.setLanguage(langParam);
  }


  return (

    <WonderPush options={{
      webKey: process.env.REACT_APP_WONDERPUSH_WEB_KEY || "969edc47aea84b60b79a01c5b590d6bfe04dc7646b1001a09b2d51ff0ce27a8c", 
      applicationName: process.env.REACT_APP_WONDERPUSH_APP_NAME || "Sahra",
      notificationDefaultUrl: process.env.REACT_APP_WONDERPUSH_NOTIFICATION_URL || "https://pigu.chat/chat",
      notificationIcon: process.env.REACT_APP_WONDERPUSH_NOTIFICATION_ICON || "https://cdn.by.wonderpush.com/upload/01grd8o64m6kgfaq/aac77f158d271862c7130b52e20382a2f839b0b7/v1/small"
    }}>
      <Router history={history}>
        <div className="App">
          <Navbar />
          <Fragment>
            <ScrollToTop />
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/chat" component={Chat} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/recovery" component={Recovery} />
              <Route exact path="/register" component={Register} />
              <Route exact path="/autologin/:id" component={AutoLogin} />
              <Route exact path="/settings" component={Settings} />
              <Route exact path="/terms" component={Terms} />
              <Route exact path="/privacy" component={Privacy} />
              <Route exact path="/phone-login" component={PhoneLogin} />

            </Switch>
          </Fragment>
        </div>
      </Router>
    </WonderPush>
  );
}

export default App;
